"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_router__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ac85f362-9e13-400e-8c01-48217fb04bc1",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "icons-2_REVIEW"), /*#__PURE__*/React.createElement("g", {
    id: "25a6d16b-c8da-44b6-a31c-0e6d2df2e942",
    "data-name": "8dfdc78e-6b74-4680-9893-67d0c66a3f81"
  }, /*#__PURE__*/React.createElement("g", {
    id: "955697e4-2b43-40d2-afc0-e45ef4c8176f",
    "data-name": "3704130a-54df-4b1b-a961-f65befb879e4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0b28bf9-0cb4-488f-bc47-ae98468fba4f",
    "data-name": "a204b931-5bdb-47dd-a4fd-71d987c6828c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "963947bc-d517-41e4-ae5e-d20c700e40ad",
    "data-name": "011de657-4b09-41b8-b1f4-600467cb6ad1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00f5d62b-5693-4aab-b521-5a9bc5c4c4ff",
    "data-name": "5577932a-5ab2-485b-a7ab-bc4307cea679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2184fbd6-940a-448a-81c0-d79dce6c095f",
    "data-name": "ad57ad4b-08d3-45ac-916a-1c7e3bd512af"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4d442f8f-6b25-4ead-bd30-a9be0c95262b",
    "data-name": "50ae1aa2-4e70-49ab-9c1d-2840ced4a416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d28283c4-8805-4a8c-bc9d-125c16229af4",
    "data-name": "a2784140-7281-4b21-99d8-cbffb2edcc29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f368d034-e5b3-4af6-bbd3-2a3d8101a329",
    "data-name": "2936add7-45a6-4964-9c9a-b55295263321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a799f23b-358f-4bdb-b65f-062571e0e63f",
    "data-name": "0fb69f54-4346-4b9e-806d-fdb83e8573c3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5193429-a785-4892-8683-357a6fc8ac61",
    "data-name": "94e33287-5351-4ea8-9e1e-b12576a338ba"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15546d22-f2f0-4ef5-b1cc-4bc0c7350374",
    "data-name": "d8745ca1-58c6-48e2-83f5-c1ebe804b73a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92f74093-5b74-4670-a0f4-335c64f31a9f",
    "data-name": "97660fc2-9341-44cb-9dbd-f508e1d2b0de"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2298573b-7aa2-49e4-b609-be378ac999a6",
    "data-name": "d70db8aa-1a6d-4be6-bf25-d7d415affb8f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e86ada92-5020-4e72-85bd-2226734e0feb",
    "data-name": "e41bad9c-38e3-4cd4-8b31-782e83645e64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c00035a9-b292-41b8-b3a1-bf33fce6387a",
    "data-name": "31f74c97-41ae-4d65-8bac-3cd711c8e513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4ef9b64f-bfd3-48df-a877-84199b867a89",
    "data-name": "969e16a0-b64d-4248-a0f1-a57630154427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "312d934b-c131-4fc2-84e7-cc85d53146cb",
    "data-name": "43c3d162-3481-4d72-8ae2-f04070347e9f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4fce3fd1-def8-49f8-8aad-6227d36b40b5",
    "data-name": "3058dfd3-582f-473c-b74c-0a2f527af0a7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e2b2b6d0-4ff0-4f4b-9161-58ebc47fc334",
    "data-name": "0cde8957-7a2a-4595-9de1-531ed1540b30",
    d: "M43.52,63.17a73.06,73.06,0,0,1,102.82,0l0,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "1efa6e22-18e7-46cd-95c3-0e2e518a0564",
    "data-name": "6a3e9f14-3190-4286-a2ae-9ff446b5603c",
    d: "M58.41,78.62a52.23,52.23,0,0,1,73.49,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2c15441-538d-4c12-adf4-a3dadc878429",
    "data-name": "7b8da48a-eea3-4fc6-9d27-87c0010794c7",
    d: "M73.71,93.81a30.37,30.37,0,0,1,42.7,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.9,61.73a2.09,2.09,0,0,1,0,3,2.12,2.12,0,0,1-.55.4,2.15,2.15,0,0,0,2.89-.88,2.11,2.11,0,0,0-.37-2.49A74.91,74.91,0,0,0,94,40,74.87,74.87,0,0,1,145.9,61.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.16,61.49a54.1,54.1,0,0,1,37.26,15.74,2.09,2.09,0,0,1,0,3,2.12,2.12,0,0,1-.55.4,2.15,2.15,0,0,0,2.89-.88,2.11,2.11,0,0,0-.37-2.49A54.17,54.17,0,0,0,94.16,61.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.55,93.88a2.07,2.07,0,0,1-1.14,1.88,2.15,2.15,0,0,0,2.89-.88,2.11,2.11,0,0,0-.37-2.49A32.23,32.23,0,0,0,95.06,83h-1a32.2,32.2,0,0,1,21.87,9.37A2.12,2.12,0,0,1,116.55,93.88Z"
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "6feef84b-c11c-4e19-b90b-6653f8b696cc",
    "data-name": "1b74f0a0-c97e-4c27-8f6b-1b062a1d9176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d737d023-b01a-484d-9b77-fa37065d650f",
    "data-name": "88de70c2-f71d-4594-9fec-6fa7804d7349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5f71108-ae79-40ae-ab14-b8bface463b3",
    "data-name": "4e03752b-4b03-48c5-8693-c033a96c305c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7e5c5808-1fae-40bf-b32a-5bdeb0e9d835",
    "data-name": "6147fcc6-1b80-41ff-801a-6a4aab9aa2a0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "37c5587b-381f-4e7b-adac-cc1772b0c7df",
    "data-name": "1a7990ca-8d34-4368-8cff-81207460a08b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "76f6e886-0143-4a2a-9f5b-fd0d6437cc76",
    "data-name": "6874f4fd-c529-4dbe-a89f-d211ed8842d1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "67bf2101-dd16-4a7a-9ca6-cd90a49c872b",
    "data-name": "a3f4d24e-16b9-4e8d-b22e-4906f4943c61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dcb01d50-aca1-4ec5-9803-48b4c65f62c9",
    "data-name": "2bcb19de-fb09-4821-b90c-6572f9c3cd59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ebf64f44-aa33-4236-81a5-a24c9bd9876e",
    "data-name": "853d22a2-ec0a-4af6-91cb-1436644bd3f6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7985d82-657a-4fc8-8b83-e2f1376daefa",
    "data-name": "58c8374a-db0b-47a0-b893-44b0aafcd3ee"
  }, /*#__PURE__*/React.createElement("g", {
    id: "47b63b28-54df-4048-9fdc-5f858f36b399",
    "data-name": "6689b8f4-c1f2-4071-b4c4-373666532104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7ed33ef-57a7-4685-b9f2-dc104cf84644",
    "data-name": "47c6615d-4286-4202-b844-b36a6b65b4d6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4c7f7860-80a4-4eda-af82-eed9d34e4725",
    "data-name": "005e1986-d7fc-43cc-afb1-d5feb6d7cc86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4349b1c4-9a8e-4d69-bf21-4270c3a406bd",
    "data-name": "49a167e5-0eef-455f-9e6e-34a70395f72d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e780b54d-865a-41e0-ae0f-96fc60612bfb",
    "data-name": "cff4b08e-e662-452e-b2a1-f3b4a2ee2b99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7e900796-f0d0-43a7-be32-ad3ed710f76b",
    "data-name": "2245dc6d-abd6-469d-a559-68149f53035a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,152H32a16,16,0,0,1-16-16V116a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v20A16,16,0,0,1,160,152Z",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("circle", {
    cx: 96.02,
    cy: 122,
    r: 6,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,152H32a16,16,0,0,1-16-16H176A16,16,0,0,1,160,152Z",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 136,
    width: 160,
    height: 2,
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 142,
    width: 12,
    height: 6,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 146,
    width: 12,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 142,
    width: 12,
    height: 6,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 146,
    width: 12,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 142,
    width: 12,
    height: 6,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 146,
    width: 12,
    height: 2,
    opacity: 0.06
  }));
}

var _default = ic_router__dark;
exports.default = _default;